export const APP_NAME = 'VNGGames Card';
export const APP_DESCRIPTION = 'The reputable game card-selling website of VNGGames';

export const DEFAULT_LANGUAGE = {
	value: 'EN',
	label: 'English',
};

export const DEFAULT_MARKET = {
	value: 'SG',
	label: 'Singapore',
	flag: 'flag-sg',
};

export const LANGUAGES = [
	{
		value: 'EN',
		label: 'English',
	},
	{
		value: 'TH',
		label: 'ภาษาไทย',
	},
	{
		value: 'ID',
		label: 'Bahasa Indonesia',
	},
];

export const REGIONS = [
	{
		value: 'ID',
		label: 'Indonesia',
		flag: 'flag-id',
	},
	{
		value: 'PH',
		label: 'Philippines',
		flag: 'flag-ph',
	},
	{
		value: 'TH',
		label: 'Thailand',
		flag: 'flag-th',
	},
	{
		value: 'MY',
		label: 'Malaysia',
		flag: 'flag-my',
	},
	{
		value: 'SG',
		label: 'Singapore',
		flag: 'flag-sg',
	},
];

const LANGUAGE_LIST = {
	ID: 'ID',
	TH: 'TH',
	PH: 'PH',
	MY: 'MY',
	SG: 'SG',
	EN: 'EN',
};

export const LANGUAGE_REGION_CONFIG = {
	[LANGUAGE_LIST.ID]: {
		value: 'ID',
		label: 'Indonesia',
		faqRoute: '/faq/id-ID',
		userGuideRoute: '/user-guide/id-ID',
		userGuideImageRoute: 'images/user-guide/id-ID/',
	},
	[LANGUAGE_LIST.TH]: {
		value: 'TH',
		label: 'ภาษาไทย',
		faqRoute: '/faq/th-TH',
		userGuideRoute: '/user-guide/th-TH',
		userGuideImageRoute: 'images/user-guide/th-TH/',
	},
	[LANGUAGE_LIST.EN]: {
		value: 'EN',
		label: 'English',
		faqRoute: '/faq/en',
		userGuideRoute: '/user-guide/en',
		userGuideImageRoute: 'images/user-guide/en/',
	},
};

export const CURRENCY_OPTION = {
	currencyDisplay: 'narrowSymbol',
	useGrouping: true,
	notation: 'standard',
};

export const CURRENCY_OPTION_NOFD = {
	...{ CURRENCY_OPTION },
	...{ maximumFractionDigits: 0 },
};

export const PAYMENT_CHANNELS_ID = {
	RAZER_GOLD: 1,
	UNION_BANK: 2,
	UCPB: 3,
	PAYPAL: 4,
	RCBC: 5,
	METROBANK: 6,
	MAYBANK_PH: 7,
	BPI: 8,
	BDO: 9,
	FPX: 10,
	QRIS: 11,
	SCB: 12,
	KTB: 13,
	KBANK: 14,
	BBL: 15,
	BAY: 16,
	PAYNOW: 17,
	GCASH: 18,
	KTB_NEW: 19,
	KBANK_NEW: 20,
	BBL_NEW: 21,
	BAY_NEW: 22,
	SCB_NEW: 23,
};
export const PAYMENT_CHANNELS = {
	[PAYMENT_CHANNELS_ID.RAZER_GOLD]: {
		id: 'RAZER_GOLD',
		logo: '/images/pm-method/logo2x1/1_rzg.png',
	},
	[PAYMENT_CHANNELS_ID.UNION_BANK]: {
		id: 'UNION_BANK',
		logo: '/images/pm-method/logo2x1/2_UnionBank.png',
	},
	[PAYMENT_CHANNELS_ID.UCPB]: {
		id: 'UCPB',
		logo: '/images/pm-method/logo2x1/3_ucpb.png',
	},
	[PAYMENT_CHANNELS_ID.PAYPAL]: {
		id: 'PAYPAL',
		logo: '/images/pm-method/logo2x1/4_paypal.png',
	},
	[PAYMENT_CHANNELS_ID.RCBC]: {
		id: 'RCBC',
		logo: '/images/pm-method/logo2x1/5_rcbc.png',
	},
	[PAYMENT_CHANNELS_ID.METROBANK]: {
		id: 'METROBANK',
		logo: '/images/pm-method/logo2x1/6_metrobank.png',
	},
	[PAYMENT_CHANNELS_ID.MAYBANK_PH]: {
		id: 'MAYBANK_PH',
		logo: '/images/pm-method/logo2x1/7_MaybankPH.png',
	},
	[PAYMENT_CHANNELS_ID.BPI]: {
		id: 'BPI',
		logo: '/images/pm-method/logo2x1/8_bpi.png',
	},
	[PAYMENT_CHANNELS_ID.BDO]: {
		id: 'BDO',
		logo: '/images/pm-method/logo2x1/9_bdo.png',
	},
	[PAYMENT_CHANNELS_ID.FPX]: {
		id: 'FPX',
		logo: '/images/pm-method/logo2x1/10_fpx.png',
	},
	[PAYMENT_CHANNELS_ID.QRIS]: {
		id: 'QRIS',
		logo: '/images/pm-method/logo2x1/11_qris.png',
	},
	[PAYMENT_CHANNELS_ID.SCB]: {
		id: 'SCB',
		logo: '/images/pm-method/logo2x1/12_scb.png',
	},
	[PAYMENT_CHANNELS_ID.KTB]: {
		id: 'KTB',
		logo: '/images/pm-method/logo2x1/13_ktb.png',
	},
	[PAYMENT_CHANNELS_ID.KBANK]: {
		id: 'KBANK',
		logo: '/images/pm-method/logo2x1/14_kbank.png',
	},
	[PAYMENT_CHANNELS_ID.BBL]: {
		id: 'BBL',
		logo: '/images/pm-method/logo2x1/15_bbl.png',
	},
	[PAYMENT_CHANNELS_ID.BAY]: {
		id: 'BAY',
		logo: '/images/pm-method/logo2x1/16_bay.png',
	},
	[PAYMENT_CHANNELS_ID.PAYNOW]: {
		id: 'PAYNOW',
		logo: '/images/pm-method/logo2x1/17_paynow.png',
	},
	[PAYMENT_CHANNELS_ID.GCASH]: {
		id: 'GCASH',
		logo: '/images/pm-method/logo2x1/18_gcash.png',
	},
	[PAYMENT_CHANNELS_ID.KTB_NEW]: {
		id: 'KTB_NEW',
		logo: '/images/pm-method/logo2x1/19_ktb.png',
	},
	[PAYMENT_CHANNELS_ID.KBANK_NEW]: {
		id: 'KBANK_NEW',
		logo: '/images/pm-method/logo2x1/20_kbank.png',
	},
	[PAYMENT_CHANNELS_ID.BBL_NEW]: {
		id: 'BBL_NEW',
		logo: '/images/pm-method/logo2x1/21_bbl.png',
	},
	[PAYMENT_CHANNELS_ID.BAY_NEW]: {
		id: 'BAY_NEW',
		logo: '/images/pm-method/logo2x1/22_bay.png',
	},
	[PAYMENT_CHANNELS_ID.SCB_NEW]: {
		id: 'SCB_NEW',
		logo: '/images/pm-method/logo2x1/23_scb.png',
	},
};

export const DISCOUNT = 10;
export const LIMIT_QUANTITY = 10;
export const LOCAL_STORAGE_AUTH_ID = 'epin_usr_s';
export const LOCAL_STORAGE_APP_ID = 'epin_app_s';
export const LOCAL_STORAGE_CART_ID = 'epin_cart_s';

export const ORDER_STATUS = {
	INCOMPLETE: -1,
	AWAITING_PAYMENT: 0,
	DELIVERED: 1,
	DELIVERY_ERROR: 2,
	READY_DELIVERY: 3,
	AWAITING_DELIVERY: 4,
	AWAITING_FULFILLMENT: 5,
};

export const POLLING_STATUS = {
	LIMITED_EXCEED: 'LIMITED_EXCEED',
};

export const DATE_RANGES_SELECT_OPTIONS = [
	{
		label: 'duration.oneWeek',
		value: '7--days',
	},
	{
		label: 'duration.oneMonth',
		value: '1--months',
	},
	{
		label: 'duration.threeMonths',
		value: '3--months',
	},
];
export const ORDER_STATUSES_SELECT_OPTIONS = [
	{
		label: 'all',
		value: 'all',
	},
	{
		label: 'successful',
		value: ORDER_STATUS.DELIVERED,
	},
	{
		label: 'failed',
		value: ORDER_STATUS.INCOMPLETE,
	},
];

export const CARD_STATUSES = [
	{
		label: 'all',
		value: 'all',
	},
	{
		label: 'sold',
		value: 'sold',
	},
	{
		label: 'available',
		value: 'available',
	},
];

export const QUANTITY_LIMIT = 99;

export const USER_GUIDE_CONTENT_MENU = [
	{
		title: 'userGuide.chap1',
		_id: '#chap-vnggames-card',
		isChildren: false,
	},
	{
		title: 'userGuide.viewProductsListTitle',
		_id: '#view-products-list',
		isChildren: true,
	},
	{
		title: 'userGuide.registerTitle',
		_id: '#register-account',
		isChildren: true,
	},
	{
		title: 'userGuide.loginTitle',
		_id: '#login-account',
		isChildren: true,
	},
	{
		title: 'userGuide.buyCardTitle',
		_id: '#buy-card',
		isChildren: true,
	},
	{
		title: 'userGuide.orderHistoyTitle',
		_id: '#order-history',
		isChildren: true,
	},
	{
		title: 'userGuide.cardManagementTitle',
		_id: '#card-management',
		isChildren: true,
	},
	{
		title: 'userGuide.chap2',
		_id: '#chap-redeem-on-vng-games-card',
		isChildren: false,
	},
];

export const FAQ_CONTENT_MENU = [
	{
		title: 'faq.whatIsVNGGamesCard',
		_id: '#what-is-vng-game-card',
		isChildren: false,
	},
	{
		title: 'faq.benefits',
		_id: '#benefits-of-pay',
		isChildren: false,
	},
	{
		title: 'faq.whereToPurchase',
		_id: '#where-to-purchase',
		isChildren: false,
	},
	{
		title: 'faq.howToRedeem',
		_id: '#redeem-game-cards',
		isChildren: false,
	},
	{
		title: 'faq.errorWhenRedeem',
		_id: '#error-when-redeem',
		isChildren: false,
	},
	{
		title: 'faq.errorWhenPurchaseViaBank',
		_id: '#error-when-purchase-via-bank',
		isChildren: false,
	},
	{
		title: 'faq.errorWhenPurchaseViaEWallet',
		_id: '#error-payment-with-e-wallet',
		isChildren: false,
	},
];

export const EMAIL_HISTORY_STATUS_CODE = {
	READY: 'READY',
	SUCCESSFUL: 'SUCCESSFUL',
	ERROR: 'ERROR',
	FAIL: 'FAIL',
};

export const OTP_ERROR_CODE = {
	INVALID_OTP: 'INVALID_OTP',
	VERIFY_REQUEST_LIMIT: 'VERIFY_OTP_REQUEST_LIMIT_EXCEEDED',
	SEND_REQUEST_LIMIT: 'SEND_OTP_REQUEST_LIMIT_EXCEEDED',
	ACTION_FAST: 'ACTION_TO_FAST',
};

export const TOKEN_ERROR_CODE = {
	INVALID_TOKEN_AUTH: 'INVALID_TOKEN',
	INVALID_TOKEN_MFA: 'INVALID_TOKEN_MFA',
};

export const LOGIN_REQUIRED_ROUTES = [
	'checkout',
	'email-history',
	'my-cards',
	'payment-callback',
	'result',
	'transaction-history',
];

export const FREE_ROUTES = ['index', 'auth', 'login-auth', 'products', 'terms-of-sale', 'user-guide', 'faq'];

export const CUSTOM_TAG_VALUE = {
	HTTP_CLIENT: 'http.client',
};
